<span class="title">Veuillez entrer votre adresse e-mail</span>
<div class="inputs-wrapper">
  <span class="label">Mail</span>
  <input [(ngModel)]="email" placeholder="Adresse e-mail" (blur)="validateEmail()" (ngModelChange)="resetMessage()" (keyup.enter)="sendPasswordResetEmail(email)" />
</div>
<span *ngIf="message" [ngClass]="error ? 'error-message' : 'message'">{{ message }}</span>
<app-button size="sm" (click)="sendPasswordResetEmail(email)" [disabled]="!email || loading || message !== ''" text="Valider" color="#fff"></app-button>